import { Theme } from '@astryxdesign/core/theme';
import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Storefront } from '@phosphor-icons/react';
import { studioTheme } from '../app/theme';

/** The root has no studio of its own; each studio lives at /s/<slug>/. */
export function LandingPage() {
  return (
    <Theme theme={studioTheme('#4690FF')} mode="dark">
      <Center height="100dvh" padding={6}>
        <EmptyState
          icon={<Storefront size={44} aria-hidden />}
          title="Онлайн-запись в студию"
          description="Откройте ссылку, которую прислала студия: она выглядит как …/s/название-студии/"
        />
      </Center>
    </Theme>
  );
}
